import * as React from 'react';
import { Component } from 'react';
import { StatusBarComponent } from '../../controls/StatusBar';
import { IStatusBarInfo } from '../../models/IStatusBarInfo';
import { connect } from 'react-redux';


export function ShowStatusBar(type: 'Success' | 'Info' | 'Error', message: string, timeout?: number) {
    if (statusBarComponent !== null) {
        statusBarComponent.ShowStatusBar(type, message, timeout);
    }
}

export function ShowErrorStatus(errorResponse: any, altMessage: string, timeout?: number) {
    let errorMessage = altMessage;
    if (errorResponse) {
        if (errorResponse.response) {
            if (errorResponse.response.status === 499) {
                if (errorResponse.response.data) {
                    errorMessage = errorResponse.response.data;
                }
            }
        }
    }
    ShowStatusBar('Error', errorMessage, timeout);
}

//let statusBarInfo: IStatusBarInfo | null = null;
let statusBarComponent: GlobalStatusBarComponent | null = null;

function MapState(state) {
    return {
        StatusBarInfo: state.Status
    }
}

interface IProps {
    StatusBarInfo: IStatusBarInfo
}

class GlobalStatusBarComponent extends Component<IProps, any> {

    private StatusBarRef = React.createRef<StatusBarComponent>();

    constructor(props) {
        super(props);
    }

    public componentWillMount() {
        statusBarComponent = this;
    }

    public componentWillUnmount() {
        statusBarComponent = null;
    }

    public render() {
        return (
            <StatusBarComponent ref={this.StatusBarRef} />
        );
    }

    public ShowStatusBar(type: 'Success' | 'Info' | 'Error', message: string, timeout?: number) {
        if (this.StatusBarRef.current !== null) {
            this.StatusBarRef.current.ShowStatusBar(type, message, timeout);
        }
    }
}

export default connect(MapState)(GlobalStatusBarComponent);


// WEBPACK FOOTER //
// ./src/components/Layout/GlobalStatusBar.tsx